var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.ready,
          expression: "ready",
        },
      ],
      staticClass: "c-gallery",
      class: { "c-gallery--single": !_vm.useSwiper },
      on: {
        mouseover: function ($event) {
          return _vm.handleHover(true)
        },
        mouseleave: function ($event) {
          return _vm.handleHover(false)
        },
      },
    },
    [
      _vm.totalSlides > 1 && _vm.title
        ? _c("h3", [
            _vm._v(
              _vm._s(_vm.title) +
                " " +
                _vm._s(_vm.currentSlide) +
                "/" +
                _vm._s(_vm.totalSlides)
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "c-gallery__ctn swiper-container",
          attrs: {
            role: "region",
            "aria-roledescription": "carousel",
            "aria-label": "Slideshow",
            tabindex: "0",
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "swiper-wrapper",
              attrs: { id: `${_vm.title}-crsl` },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.slideTransition.apply(null, arguments)
                },
                blur: function ($event) {
                  return _vm.leaveSlider($event)
                },
              },
            },
            [_vm._t("default")],
            2
          ),
          _vm._v(" "),
          _vm.share
            ? _c(
                "a",
                {
                  staticClass: "c-video__sharing a2a_dd",
                  attrs: {
                    "data-a2a-url": _vm.share,
                    href: `https://www.addtoany.com/share#url=${_vm.share}`,
                  },
                },
                [_c("icon", { attrs: { glyph: "share" } })],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.useSwiper
            ? _c(
                "div",
                {
                  staticClass: "c-gallery__button-wrap",
                  class: { isVisible: _vm.showButtons },
                  attrs: {
                    tabindex: "0",
                    role: "group",
                    "aria-label": "Slide controls",
                  },
                },
                [
                  _c(
                    "a",
                    {
                      ref: "prev",
                      staticClass: "c-gallery__button swiper-button-prev",
                      class: { "swiper-button-disabled": _vm.isBeginning },
                      attrs: {
                        role: "button",
                        "aria-label": "Previous Slide",
                        "aria-controls": `${_vm.title}-crsl`,
                        "aria-disabled": _vm.isBeginning,
                        href: "#",
                      },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.prevSlide.apply(null, arguments)
                        },
                        focus: function ($event) {
                          return _vm.bttnIn($event)
                        },
                        blur: function ($event) {
                          return _vm.bttnOut($event)
                        },
                      },
                    },
                    [
                      _c("uc-icon", {
                        attrs: { glyph: "arrow-left", alt: "Arrow Left" },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      ref: "next",
                      staticClass: "c-gallery__button swiper-button-next",
                      class: { "swiper-button-disabled": _vm.isEnd },
                      attrs: {
                        role: "button",
                        "aria-label": "Next Slide",
                        "aria-controls": `${_vm.title}-crsl`,
                        "aria-disabled": _vm.isEnd,
                        href: "#",
                      },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.nextSlide($event)
                        },
                        focus: function ($event) {
                          return _vm.bttnIn($event)
                        },
                        blur: function ($event) {
                          return _vm.bttnOut($event)
                        },
                      },
                    },
                    [
                      _c("uc-icon", {
                        attrs: { glyph: "arrow-right", alt: "Arrow Right" },
                      }),
                    ],
                    1
                  ),
                ]
              )
            : _vm._e(),
        ]
      ),
      _vm._v(" "),
      _c("uc-caption", {
        attrs: { description: _vm.description, credit: _vm.credit },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }